var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',[_c('v-card-title',{staticClass:"green lighten-4 primary--text font-weight-bold"},[_vm._v("Orientações Indicação PCD")]),_c('v-card-text',{staticClass:"pt-6",domProps:{"innerHTML":_vm._s(_vm.configPcd.orientacoes_pcd)}}),_c('v-card-actions',[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }